import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import ScrollToTop from "@/components/ScrollToTop";
import { useSEO } from "@/lib/seo";
import { useSchema } from "@/lib/schema";

export default function Layout() {
  useSEO();
  useSchema();
  return (
    <div className="min-h-screen bg-paper text-ink antialiased">
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
